import { render } from "./InspectionStart.vue?vue&type=template&id=196fca10"
import script from "./InspectionStart.vue?vue&type=script&lang=js"
export * from "./InspectionStart.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__